/**
 * SummaryGrid — 5 stat cards for the Current Date tab (CR-0015 / C-27).
 */
import StatCard from "@/components/report/StatCard";
import { fmtTime } from "@/utils/fmtTime";

export default function SummaryGrid({ summary }) {
  if (!summary) return null;
  return (
    <div
      data-testid="summary-grid"
      className="mx-4 mt-3 bg-white rounded-md shadow-sm border px-5 py-4"
      style={{ borderColor: "#E5E7EB" }}
    >
      <div className="text-lg font-bold mb-3" style={{ color: "#111827" }}>
        Summary
      </div>
      <div className="flex flex-wrap gap-3 justify-center">
        <StatCard
          testId="stat-rooms"
          bg="#DBEAFE"
          fg="#2563EB"
          value={summary.total_rooms}
          label="Total Rooms"
        />
        <StatCard
          testId="stat-sessions"
          bg="#FED7AA"
          fg="#EA580C"
          value={summary.total_sessions}
          label="Total Sessions"
        />
        <StatCard
          testId="stat-avg"
          bg="#DCFCE7"
          fg="#16A34A"
          value={fmtTime(summary.avg_seconds)}
          label="Avg. Time"
        />
        <StatCard
          testId="stat-max"
          bg="#FECACA"
          fg="#DC2626"
          value={fmtTime(summary.max_seconds)}
          label="Max Time"
        />
        <StatCard
          testId="stat-min"
          bg="#E9D5FF"
          fg="#7C3AED"
          value={fmtTime(summary.min_seconds)}
          label="Min Time"
        />
      </div>
    </div>
  );
}
